import { createContext } from '../../utils/createContext.js';
export const [AccordionItemProvider, useAccordionItemContext] = createContext('accordion-item-context');
